import { useState, useEffect } from "react";
import { ReactLenis } from "lenis/react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import SocialProof from "@/components/landing/SocialProof";
import Features from "@/components/landing/Features";
import Verticals from "@/components/landing/Verticals";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
// eslint-disable-next-line no-unused-vars
// import PricingComparison from "@/components/landing/PricingComparison"; // Reactivar cuando existan múltiples planes (Plus / Pro)
import FAQ from "@/components/landing/FAQ";
import CTAFinal from "@/components/landing/CTAFinal";
import Footer from "@/components/landing/Footer";
import DemoModal from "@/components/landing/DemoModal";
import { scrollDepth } from "@/lib/analytics";

export default function LandingPage() {
  const [demoOpen, setDemoOpen] = useState(false);
  const [demoVertical, setDemoVertical] = useState("");

  const openDemo = (vertical) => {
    setDemoVertical(vertical || "");
    setDemoOpen(true);
  };

  useEffect(() => {
    const depths = [25, 50, 75, 100];
    const watchers = depths.map((d) => {
      const sentinel = document.createElement("div");
      sentinel.dataset.scrollSentinel = String(d);
      document.body.appendChild(sentinel);
      const observer = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) { scrollDepth(d); observer.disconnect(); } },
        { threshold: 0 }
      );
      observer.observe(sentinel);
      return () => { observer.disconnect(); sentinel.remove(); };
    });
    return () => watchers.forEach((w) => w());
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div
        data-testid="landing-page"
        className="min-h-screen bg-[#F2EDE3] text-[#111111] font-['Satoshi'] overflow-x-hidden"
      >
        <Navbar onDemoClick={() => openDemo()} />
        <Hero onDemoClick={() => openDemo()} />
        {/* <SocialProof /> */}
        <Features onDemoClick={() => openDemo()} />
        <Verticals onDemoClick={(v) => openDemo(v)} />
        <HowItWorks />
        <Pricing onDemoClick={() => openDemo()} />
        {/* <PricingComparison /> reactivar cuando haya múltiples planes */}
        <FAQ />
        <CTAFinal onDemoClick={() => openDemo()} />
        <Footer />
      </div>
      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} vertical={demoVertical} />
    </ReactLenis>
  );
}
